import React, { ReactNode } from "react";
import { RectangleContainer } from "../atoms/rectangle-container";

interface RectangleListProps {
  items: ReactNode[]; // Array of text for each rectangle item
}

export const RectangleList: React.FC<RectangleListProps> = ({ items }) => {
  return (
    <div className="rounded-2xl border-dark-gray">
      {items.map((item, index) => (
        <RectangleContainer key={index} children={item} />
      ))}
    </div>
  );
};
